import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { CaretLinkProps } from "./CaretLink";

const baseLinkStyle = css`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  color: ${(props) => props.color || `inherit`};
  width: fit-content;
  padding: ${(props) => props.pd || ``};

  cursor: pointer;
  align-self: ${(props) => props.align || ``};
  align-items: baseline;
  text-align: left;
  &.right {
    flex-direction: row;
  }
  &.left {
    flex-direction: row-reverse;
  }
  .caret {
    position: relative;
    transition: all 500ms ease-in-out;
    width: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    height: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    top: calc(${(props: CaretLinkProps) => props.fontSize || 1}rem * 0.2);
    &.right {
      left: 0;
      margin-left: calc(
        ${(props: CaretLinkProps) => props.fontSize || 1}rem * 0.2
      );
    }
    &.left {
      right: 0;
      margin-right: calc(
        ${(props: CaretLinkProps) => props.fontSize || 1}rem * 0.2
      );
      transform: scaleX(-1);
    }
  }
  a > div > p,
  a > .caret {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
    font-size: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    line-height: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    color: ${(props) => props.color || `inherit`};
  }

  p,
  .caret {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
    font-size: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    line-height: ${(props: CaretLinkProps) => props.fontSize || 1}rem;
    color: ${(props) => props.color || `inherit`};
    text-align: left;
  }

  &:hover:not(.disabled) {
    border-bottom-width: 2px;
    margin-bottom: 0px;
    .caret {
      position: relative;
      transition: all 500ms ease-in-out;
      &.right {
        left: calc(${(props: CaretLinkProps) => props.fontSize || 1}rem * 0.6);
      }
      &.left {
        right: calc(${(props: CaretLinkProps) => props.fontSize || 1}rem * 0.6);
      }
    }
  }

  &:active {
    p,
    .caret {
      color: grey;
    }
  }

  &.disabled {
    pointer-events: none;

    p,
    .caret {
      color: grey;
    }
  }
`;

export const StyledLink = styled(Link)<CaretLinkProps>`
  ${baseLinkStyle}
`;

export const StyledExternalLink = styled.a<CaretLinkProps>`
  ${baseLinkStyle}
`;
